import RefreshIcon from "@mui/icons-material/Refresh";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Link, useRouteError } from "react-router";

/**
 * What a page shows when it throws.
 *
 * Without one of these, react-router's own screen takes over and shows the
 * error and its stack — which is what the Live Dashboard did on 2026-08-06 when
 * a date picker threw on mount. That is a debugging tool pointed at the wrong
 * audience: it tells an admin nothing they can act on and puts bundle paths on
 * screen. The message still reaches the console, where it belongs.
 */
const ErrorPage = () => {
	const error = useRouteError();

	if (error) {
		console.error("Route error:", error);
	}

	return (
		<Box
			sx={{
				flexGrow: 1,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				gap: 2,
				py: 8,
				textAlign: "center",
			}}
		>
			<Typography variant="h4" sx={{ fontWeight: 700 }}>
				This page stopped working
			</Typography>
			<Typography sx={{ color: "text.secondary", maxWidth: 520 }}>
				Nothing was lost — the page failed to draw, not to save. Reloading
				usually clears it. If it does not, the details are in the browser
				console.
			</Typography>
			<Box sx={{ display: "flex", gap: 1.5, mt: 1 }}>
				<Button
					variant="contained"
					startIcon={<RefreshIcon />}
					onClick={() => window.location.reload()}
				>
					Reload
				</Button>
				<Button component={Link} to="/overview" variant="outlined">
					Go to Overview
				</Button>
			</Box>
		</Box>
	);
};

export default ErrorPage;
